import React from 'react';
import PropTypes from 'prop-types';

function LinkIcon({ color = 'black', width = 22, height = 22 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6002 14.2992L15.9505 12.6495L17.6002 10.9998C18.0336 10.5665 18.3773 10.052 18.6118 9.48583C18.8464 8.91963 18.9671 8.31278 18.9671 7.69992C18.9671 7.08707 18.8464 6.48022 18.6118 5.91402C18.3773 5.34782 18.0336 4.83336 17.6002 4.40001C17.1669 3.96666 16.6524 3.6229 16.0862 3.38838C15.52 3.15385 14.9131 3.03314 14.3003 3.03314C13.6874 3.03314 13.0806 3.15385 12.5144 3.38838C11.9482 3.6229 11.4337 3.96666 11.0004 4.40001L9.35072 6.04967L7.70105 4.40001L9.35072 2.75034C10.6671 1.45525 12.4419 0.732773 14.2885 0.740292C16.1351 0.747812 17.904 1.48471 19.2097 2.79049C20.5155 4.09626 21.2524 5.86511 21.2599 7.71173C21.2675 9.55836 20.545 11.3331 19.2499 12.6495L17.6002 14.2992ZM14.2997 17.5997L12.65 19.2493C12.002 19.908 11.2299 20.4319 10.3784 20.7907C9.52686 21.1496 8.6127 21.3362 7.68866 21.34C6.76462 21.3438 5.84897 21.1645 4.99454 20.8127C4.14012 20.4608 3.36381 19.9432 2.71041 19.2898C2.05701 18.6364 1.53944 17.8601 1.18756 17.0057C0.835679 16.1513 0.656452 15.2356 0.660214 14.3116C0.663977 13.3875 0.850655 12.4734 1.20948 11.6218C1.56831 10.7703 2.09218 9.99823 2.75088 9.35017L4.40055 7.70051L6.05021 9.35017L4.40055 10.9998C3.9672 11.4332 3.62344 11.9477 3.38892 12.5139C3.15439 13.0801 3.03368 13.6869 3.03368 14.2998C3.03368 14.9126 3.15439 15.5195 3.38892 16.0857C3.62344 16.6519 3.9672 17.1663 4.40055 17.5997C4.8339 18.033 5.34836 18.3768 5.91456 18.6113C6.48076 18.8458 7.08761 18.9665 7.70047 18.9665C8.31332 18.9665 8.92017 18.8458 9.48637 18.6113C10.0526 18.3768 10.567 18.033 11.0004 17.5997L12.65 15.95L14.2997 17.5997ZM14.2997 6.04967L15.9505 7.70051L7.70105 15.9488L6.05021 14.2992L14.2997 6.05084V6.04967Z"
        fill={color}
      />
    </svg>
  );
}

LinkIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default LinkIcon;
